import { Components } from '@mui/material/styles/components';
import { ControllerFont, ControllerFontType } from '../../fonts';
import { ControllerTypographyColor } from '../../palette';

export const TypographyComponent: Components = {
  MuiTypography: {
    styleOverrides: {
      root: {
        color: 'inherit',

        //
        // mason classes
        //
        '&.MasonTextLight': {
          color: String(ControllerTypographyColor.Light),
        },
        '& .MasonTextPrimary': {
          color: String(ControllerTypographyColor.Primary),
        },
        '&.MasonTextSecondary': {
          color: String(ControllerTypographyColor.Secondary),
        },
      },
    },
    variants: [
      {
        props: { variant: ControllerFontType.Body300R },
        style: ControllerFont.Body300R,
      },
      {
        props: { variant: ControllerFontType.Body400R },
        style: ControllerFont.Body400R,
      },
      {
        props: { variant: ControllerFontType.Body500R },
        style: ControllerFont.Body500R,
      },
      {
        props: { variant: ControllerFontType.Decor200R },
        style: ControllerFont.Decor200R,
      },
      {
        props: { variant: ControllerFontType.Decor200M },
        style: ControllerFont.Decor200M,
      },
      {
        props: { variant: ControllerFontType.Decor300R },
        style: ControllerFont.Decor300R,
      },
      {
        props: { variant: ControllerFontType.Decor400R },
        style: ControllerFont.Decor400R,
      },
      {
        props: { variant: ControllerFontType.Heading200M },
        style: ControllerFont.Heading200M,
      },
      {
        props: { variant: ControllerFontType.Heading200B },
        style: ControllerFont.Heading200B,
      },
      {
        props: { variant: ControllerFontType.Heading250M },
        style: ControllerFont.Heading250M,
      },
      {
        props: { variant: ControllerFontType.Heading300B },
        style: ControllerFont.Heading300B,
      },
      {
        props: { variant: ControllerFontType.Heading300H },
        style: ControllerFont.Heading300H,
      },
      {
        props: { variant: ControllerFontType.Heading400R },
        style: ControllerFont.Heading400R,
      },
      {
        props: { variant: ControllerFontType.Heading400B },
        style: ControllerFont.Heading400B,
      },
      {
        props: { variant: ControllerFontType.Heading400H },
        style: ControllerFont.Heading400H,
      },
      {
        props: { variant: ControllerFontType.Heading500H },
        style: ControllerFont.Heading500H,
      },
      {
        props: { variant: ControllerFontType.Heading600H },
        style: ControllerFont.Heading600H,
      },
      {
        props: { variant: ControllerFontType.Text200R },
        style: ControllerFont.Text200R,
      },
      {
        props: { variant: ControllerFontType.Text300M },
        style: ControllerFont.Text300M,
      },
      {
        props: { variant: ControllerFontType.Text350R },
        style: ControllerFont.Text350R,
      },
      {
        props: { variant: ControllerFontType.Text400M },
        style: ControllerFont.Text400M,
      },
      {
        props: { variant: ControllerFontType.Text500M },
        style: ControllerFont.Text500M,
      },
    ],
  },
};
